import { OrderStatus } from "../generated/graphql";

// A confirmed order can only be sent to a provider once its comments are
// translated. The orders received through the websocket-api only carry
// hasUntranslatedComment, without the comment texts
export const canSelectOrder = (order: {
  orderComment?: Array<{ translatedComment?: string | null }>;
  hasUntranslatedComment?: boolean;
  status: OrderStatus;
}): boolean => {
  const hasUntranslatedComment =
    order?.hasUntranslatedComment ??
    (order?.orderComment ?? []).some(
      comment => comment.translatedComment === null
    );

  return !hasUntranslatedComment || order?.status !== OrderStatus.Confirmed;
};

export const formatOrderCount = (count: number): string => {
  return count === 1 ? "order" : "orders";
};

export const getSelectedOrdersText = (
  selectedCount: number,
  totalDisplayed: number
): string => {
  if (selectedCount === 0) return "";

  return `, ${selectedCount} selected out of ${totalDisplayed} ${formatOrderCount(totalDisplayed)}`;
};

// A provider leaves the page of an order assigned to another group. Its
// previous provider only receives its id, without any providerGroupId
export const shouldLeaveOrder = (
  order: { id?: string; providerGroupId?: string | null } | undefined,
  userGroupId: string | undefined,
  orderId: string | undefined
): boolean => order?.id === orderId && order?.providerGroupId !== userGroupId;
